// Section 18: Migration policy. Open / Skilled only / Families only / Closed / Ask each time
// (Section 14). Default: config.policies.defaults.migration (Ask each time). Any option but Ask
// decides at the gate without a prompt (phases/events/gate.ts, stream E2): Open admits all, Closed
// turns away, Skilled only admits those claiming skill 3+ in a job nobody here has at 3+ (and their
// young children), Families only admits groups with children. The preview names the rule and the
// admitted newcomers still on probation as guests.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { definePolicy, noModifiers } from '../../core/registry';
import type { PreviewLine } from '../../core/types';

export function migration(config: Config) {
  return definePolicy({
    id: 'migration',
    label: 'Migration',
    section: 'S18',
    group: 'society',
    options: ['open', 'skilled-only', 'families-only', 'closed', 'ask'],
    default: config.policies.defaults.migration,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option): readonly PreviewLine[] {
      const lines: PreviewLine[] = [{ key: `policy.migration.${option}`, params: {} }];
      let guests = 0;
      for (const p of Object.values(ctx.state.people)) if (p.status.guest !== null) guests++;
      if (guests > 0) lines.push({ key: 'policy.migration.guests', params: { count: guests } });
      const closed = ctx.state.counters.gatesClosedUntilTurn;
      if (closed !== null && closed >= ctx.season.turn)
        lines.push({ key: 'policy.migration.gates-closed', params: { turn: closed } });
      return lines;
    },
    validate: noProblem,
  });
}
